import React from 'react';
import { Provider } from 'react-redux';
import store from './src/state/store';
import "bootstrap/dist/js/bootstrap.min.js";
import "@popperjs/core/dist/umd/popper.min.js";

export const wrapRootElement = ({ element }) => {
  return <Provider store={store}>{element}</Provider>;
};